import PilotCopilotThreadsAPI from 'dashboard/api/pilot/copilotThreads';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotCopilotThreads',
  API: PilotCopilotThreadsAPI,
  actions: mutationTypes => ({
    async deleteAll({ commit }) {
      commit(mutationTypes.SET_UI_FLAG, { deletingItem: true });
      try {
        await PilotCopilotThreadsAPI.destroyAll();
        commit(mutationTypes.SET, []);
        commit(mutationTypes.SET_META, { total_count: 0, page: 1 });
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { deletingItem: false });
      }
    },
  }),
});
